import {create} from 'zustand';
import {devtools, persist} from 'zustand/middleware';
import {Address, AnyObject, Hash} from "../types";

export interface TransactionInfo {
    from: Address;
    hash: Hash;
    input: Hash;
    timestamp: string;
    to: Address;
    value: string;
    source:"local"
    extra?:AnyObject
}

interface TransactionStore {
    transactions: Record<string, TransactionInfo[]>;


    addTransaction: (data: { chainId: number;address:Address; hash: string; info: TransactionInfo }) => void;

    removeTransaction: (data: { chainId: number;address:Address;  hash: string }) => void;
}

const persistedState = persist<TransactionStore>(
    (set, get) => ({
        transactions: {},

        addTransaction: (data) => {
            set((state) => {
                const updatedTransactions = {
                    ...state.transactions,
                    [`${data.chainId}-${data.address}`]: [data.info,...(state.transactions[`${data.chainId}-${data.address}`] || [])],
                };
                return {transactions: updatedTransactions};
            });
        },
        removeTransaction: (data) => {
            set((state) => {
                const updatedTransactions = {
                    ...state.transactions,
                    [`${data.chainId}-${data.address}`]: (state.transactions[`${data.chainId}-${data.address}`] || [])
                        .filter((tx) => tx.hash !== data.hash)
                };
                return {transactions: updatedTransactions};
            });
        },
    }),
    {name: 'match-transactions-local'}
);

const useTransactionStore = create(devtools(persistedState));

export default useTransactionStore;
